import { useQuery } from '@tanstack/react-query'

import { accountService } from 'src/services'
import { QUERY_KEYS } from 'src/constants'

export const useGetAccountRedirectUrl = (
  accountId: string | null,
  productId: string | null,
  locale: string,
) => {
  return useQuery(
    [QUERY_KEYS.GET_ACCOUNT_REDIRECT_URL, accountId || productId, locale],
    () => accountService.getAccountRedirectUrls(accountId, productId, locale),
    {
      enabled: (!!accountId || !!productId) && !!locale,
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  )
}
